import { ChartState } from "./types";

export const defaultState = (): ChartState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    charts: [],
    links: {}
  };
};

export const state = defaultState();
